import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ScrollView, Alert } from 'react-native';

import { View } from 'react-native';

import Text from '../../../../components/common/text';
import KeyValueListView from '../../../../components/common/key-value-list-view';
import styles from './single-transaction.styles';
import NavigationArrow from '../../../../components/common/navigation-arrow';

class  SingleTransaction extends Component{

  constructor(props){
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    const { rows = [] } = this.props;
    var adviceItem = { "tradeNo": rows[0].tradeNumber}
    this.props.transact.getAdvices({
       adviceItem
    });
  }

  render() {
    const { header, detailsGroups = [], rows = [], defaultCurrency, transact, i18n: {messages}} = this.props;

    if (transact.isEmpty) {
      transact.setIsEmpty(false);
      alert(messages['app.position.transDetails']);
    }

    return (
      <div className={'single-transaction row margin-top-10'}>
        <ScrollView style={styles.root} testID="transaction-view">
          <View testID="expandable-list-item-selected">
            <View style={styles.container} testID="header">
              <Text style={styles.header}>
                {header}
              </Text>
            </View>
            <View style={styles.container} testID="details">
              <View>
                <KeyValueListView
                  detailsGroups={detailsGroups}
                  row={rows[0]}
                  widths={[0.5, 0.5]}
                  messages={messages}
                  defaultCurrency={defaultCurrency}
                />
              </View>
              <div style={{'cursor': 'pointer'}} id="txt_seeAdvice_single_transaction_test" onClick={this.toggleModal}>
              <Text> {messages['app.asset.single.advice']}</Text>
              <span className="arrowClass"><NavigationArrow/></span>
              </div>

            </View>
          </View>
        </ScrollView>
      </div>
    );
  }
}

SingleTransaction.propTypes = {
  header: PropTypes.string,
  detailsGroups: PropTypes.array,
  rows: PropTypes.array,
  defaultCurrency: PropTypes.string,
};

export default (SingleTransaction);
